import { IconCode } from "./iconCode";

/**
 * Data skupiny notifikací spolu se stavem nesoucím informaci o tom,
 * zda ve skupině existuje nepřečtená notifikace.
 * @includeToDoc
 */
export interface INotificationGroup {
    /** Typ skupiny notifikací (statické nastavení skupiny) */
    readonly type: Readonly<INotificationGroupType>;
    /** Zda je skupina nepřečtená */
    readonly unread: boolean;
}

/**
 * Skupina typů notifikací
 * @includeToDoc
 */
export interface INotificationGroupType {
    /** Název (kód) skupiny notifikací */
    readonly name: string;
    /** Kód formuláře, který se používá pro zobrazení všech notifikací skupiny */
    readonly formCode: string;
    /** Kód ikony pro skupinu */
    readonly iconCode: IconCode;
    /** Lokalizační klíč titulku v hlavičce skupiny notifikací */
    readonly titleLocKey: string;
}

export type NotificationGroupId = string;

export type NotificationItemId = number;

/**
 * Data notifikace
 * @includeToDoc
 */
export interface INotificationItem {
    /** Unikátní identifikátor */
    readonly id: NotificationItemId;
    /** Typ funkce (účelu) notifikace */
    readonly functionType: NotificationFunctionType | string;
    /** Text představující nadpis */
    readonly title?: string;
    /** Text představující obsah */
    readonly text?: string;
    /** Sdílené nastavení podle typu notifikace */
    readonly type: INotificationType;
    /** Zda je notifikace nepřečtená */
    readonly unread: boolean;
    /** Čas vytvoření notifikace */
    readonly createdDate: Date;
    /** Kód formuláře, který zobrazuje data, ke kterým se notifikace vztahuje */
    readonly formCode?: string;
    /** Id záznamu, ke kterému se notifikace vztahuje */
    readonly objId?: number;
    /** Identifikátor skupiny notifikací */
    readonly notificationGroupId: string;
}

/**
 * Typ funkce (účelu) notifikace. U každého typu se může notifikace zobrazovat jinak a provádět jinou akci při kliknutí.
 * @includeToDoc
 */
export enum NotificationFunctionType {
    generic = "GenericNotification",
    taskResult = "TaskResultNotification",
}

/**
 * Data typu notifikací
 * @includeToDoc
 */
export interface INotificationType {
    /** Název (kódové označení) typu notifikací */
    readonly name: string;
    /** Kód ikona typu notifikace */
    readonly iconCode: IconCode;
    /** Barva použitá pro notifikace daného typu */
    readonly color: string;
}
